import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 3000 }
  }

  connect() {
    this.dismiss()
  }

  dismiss() {
    setTimeout(() => {
      const alertElement = this.element.querySelector('.alert')
      if (alertElement) {
        const closeButton = alertElement.querySelector('[data-bs-dismiss="alert"]')
        if (closeButton) {
          closeButton.click()
        } else {
          // Fallback: directly remove the element if no close button
          this.element.style.transition = 'opacity 0.3s ease-out'
          this.element.style.opacity = '0'
          setTimeout(() => {
            this.element.remove()
          }, 300)
        }
      }
    }, this.delayValue)
  }
}
